import { render, staticRenderFns } from "./CTABanner.vue?vue&type=template&id=60830a58&scoped=true&lang=pug&"
import script from "./CTABanner.vue?vue&type=script&lang=js&"
export * from "./CTABanner.vue?vue&type=script&lang=js&"
import style0 from "./CTABanner.vue?vue&type=style&index=0&id=60830a58&prod&lang=scss&"
import style1 from "./CTABanner.vue?vue&type=style&index=1&id=60830a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60830a58",
  null
  
)

export default component.exports